import { ArrowLeft } from "lucide-react";
import CustomLink from "../components/shared/CustomLink";
import HealthStatus from "../components/shared/HealthStatus";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import AnalysisInfo from "../components/AIInsights/AnalysisInfo";
import PortfolioHealth from "../components/AIInsights/PortfolioHealth";
import HistoricalRiskChart from "../components/AIInsights/HistoricalRiskChart";
import AIRecommendations from "../components/AIInsights/AIRecommendations";
import TickerNews from "../components/AIInsights/TickerNews";
import { useData } from "../context/DataContext";

function AIInsights() {
	useDocumentTitle("AI Insights");
	const { aiAnalysis, aiAnalysisHistory, marketNews, loading, error } = useData();

	console.log("AI Insights data:", { aiAnalysis, aiAnalysisHistory, marketNews, loading, error });
	return (
		<>
			<div className="flex flex-col sm:flex-row justify-between w-full mt-10">
				<div className="flex w-full sm:w-fit mb-4 sm:mb-0 items-center sm:items-baseline flex-col self-start rounded-xl border border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-900 p-6 shadow-md">
					<h1 className="text-3xl font-bold mb-2">AI Portfolio Insights</h1>
					<AnalysisInfo analysis={aiAnalysis} loading={loading} />
				</div>
				<CustomLink variant="white" className="ml-auto flex items-center gap-1.5 group" href="..">
					<span className="transition-transform duration-300 group-hover:-translate-x-1">
						<ArrowLeft size={15} />
					</span>
					Home
				</CustomLink>
			</div>

			<HealthStatus error={error} />

			{/* AI Components */}
			<div className="flex flex-col gap-6 mt-6">
				<PortfolioHealth analysis={aiAnalysis} loading={loading} />
				<HistoricalRiskChart riskHistory={aiAnalysisHistory} loading={loading} />
				<AIRecommendations analysis={aiAnalysis} loading={loading} />
				<TickerNews news={marketNews} loading={loading} />
			</div>
		</>
	);
}

export default AIInsights;
